var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r_page"},[_c('el-select',{attrs:{"value":_vm.saleEntity,"placeholder":"please select your zone"},on:{"input":function($event){return _vm.$emit('update:saleEntity', $event)}}},_vm._l((_vm.optsSaleEntity),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }